import Link from "next/link";
import Nextprev from "../../components/Pagination/Nextprev";
import Image from "next/image";
import {grabImageURLFromGhostPost, removeImageFromGhostPost,} from "../../utils/utility";

const SinglePeople = props => {
    // Grab main image
    let image = (() => {
        if (grabImageURLFromGhostPost(props.post.html, "onProfilePage")) {
            return grabImageURLFromGhostPost(props.post.html, "onProfilePage");
        } else if (grabImageURLFromGhostPost(props.post.html, "onRegularList")) {
            return grabImageURLFromGhostPost(props.post.html, "onRegularList");
        } else {
            item.feature_image;
        }
    })();
    return (
        <>
            <section id="Main" className="w-full">
                <div key={props.post.id}>
                    <div className="flex flex-col md:flex-row">
                        <div className="w-full md:w-1/2">
                            <Image
                                alt={props.post.title}
                                src={image ? image : "/images/rectangle3.jpg"}
                                width="440"
                                height="550"
                                layout="responsive"
                                objectFit="cover"
                                priority
                            />
                        </div>
                        <div className="block md:hidden mb-8">
                            <Nextprev next={props.next} prev={props.prev} path={props.path}/>
                        </div>

                        <div className="flex w-full md:w-1/2 pt-6 md:pl-9">
                            <div className="self-end">
                                <div className="font-headline items-center font-extrabold text-4xl mb-2">
                                    {props.post.title}
                                </div>
                                <div className="text-gray-600 text-xl font-normal">
                                    {props.post.meta_description}
                                </div>
                                <div className="bg-blue-500 h-1 w-20 my-6"></div>
                                <div className="mb-6 text-xl text-gray-600 font-light">
                                    {props.post.custom_excerpt != null ? props.post.excerpt : ""}
                                </div>

                                {/* hidden for now */}
                                {/* <SolicalLinks
                  twitter={props.post.twitter_title}
                  linkedin={props.post.twitter_description}
                  facebook={props.post.canonical_url}
                /> */}
                            </div>
                        </div>
                    </div>
                    <div className="hidden md:block mb-8">
                        <Nextprev next={props.next} prev={props.prev} path={props.path}/>
                    </div>
                    <div className="mt-8 md:mt-0">
                        <h2 className="text-2xl font-body font-extrabold">About me</h2>
                    </div>
                    <div
                        className="ghostContent text-xl font-normal mt-4 mb-12 font-body text-gray-600"
                        dangerouslySetInnerHTML={{
                            __html: removeImageFromGhostPost(
                                removeImageFromGhostPost(props.post.html, "onProfilePage"),
                                "onRegularList"
                            ),
                        }}
                    ></div>
                </div>
                <div className="flex items-center flex-col">
                    <Link href={props.path}>
                        <button
                            className="text-center flex border-2 border-black hover:bg-black hover:text-white font-medium font-button px-8 py-2 text-sm mx-auto md:mx-4 mt-8">
                            SEE ALL INNOVATORS
                        </button>
                    </Link>
                </div>
            </section>
        </>
    );
};

export default SinglePeople;
